var map = {
	"./Gruppo di maschere 17029.png": 1758,
	"./Mockup.png": 1498,
	"./Mockup@2x.png": 5546,
	"./Raggruppa 18003.png": 2802,
	"./Raggruppa 18004.png": 9149,
	"./Raggruppa 18005.png": 8020,
	"./Raggruppa 18010.png": 2238,
	"./Raggruppa 18011.png": 9927,
	"./Raggruppa 18012.png": 1452,
	"./Raggruppa 18013.png": 7989,
	"./Raggruppa 18014.png": 42,
	"./Raggruppa 18015.png": 1619,
	"./azienda/Raggruppa 17034.gif": 3045,
	"./azienda/Raggruppa 17034.png": 5862,
	"./azienda/Risorsa 25.png": 9074,
	"./azienda/logo-meb.png": 3980,
	"./azienda/magnaebasta.svg": 3003,
	"./carousel-bk/Raggruppa 17998.png": 5121,
	"./carousel-bk/Raggruppa 17999.png": 3992,
	"./carousel-bk/Raggruppa 18000.png": 4594,
	"./carousel-bk/Raggruppa 18001.png": 8747,
	"./carousel-bk/Raggruppa 18002.png": 4928,
	"./carousel/AdobeStock_113625305.png": 9534,
	"./carousel/AdobeStock_138306903.png": 5887,
	"./carousel/AdobeStock_182726631.png": 2086,
	"./carousel/AdobeStock_268468367.png": 1182,
	"./carousel/AdobeStock_293215232.png": 5089,
	"./carousel/AdobeStock_419253624.png": 874,
	"./carousel/AdobeStock_462540795.png": 6404,
	"./carousel/AdobeStock_513099390.png": 25,
	"./flag/france.png": 3623,
	"./flag/germany.png": 4907,
	"./flag/italy.png": 7453,
	"./flag/united-kingdom.png": 71,
	"./flag/united-states.png": 7428,
	"./social/facebook.png": 6019,
	"./social/instagram.png": 7059,
	"./social/linkedin.png": 969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;